export const CHAT_LIST_WIDTH = '450px';

export const CHAT_HEADER_HEIGHT = '50px';
